"use strict";

exports.__esModule = true;
exports.GUTTER_WIDTH = exports.ALIGN_ITEMS = void 0;
var ALIGN_ITEMS = {
  start: 'start',
  end: 'end',
  center: 'center',
  stretch: 'stretch'
};
exports.ALIGN_ITEMS = ALIGN_ITEMS;
var GUTTER_WIDTH = {
  xxs: 'xxs',
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: 'xxl'
};
exports.GUTTER_WIDTH = GUTTER_WIDTH;